var map = {
	"./SBL_Traditional_Symbol_Horizontal_English_Black.svg": 9342,
	"./SBL_Traditional_Symbol_Horizontal_English_Blue.svg": 4653,
	"./SBL_Traditional_Symbol_Horizontal_English_Purple.svg": 547,
	"./SBL_Traditional_Symbol_Horizontal_English_White.svg": 6116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;